<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Cut/Sew
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Cutting</a>
          <ul>
            <li @click="activeMenuLink = '/cut-sew/incoming-orders'"><router-link to="/cut-sew/incoming-orders"  :class="{'is-active':activeMenuLink === '/cut-sew/incoming-orders'}">Incoming Orders</router-link></li>
            <li @click="activeMenuLink = '/cut-sew/cutting-overview'"><router-link to="/cut-sew/cutting-overview"  :class="{'is-active':activeMenuLink === '/cut-sew/cutting-overview'}">Cutting Overview</router-link></li>
            <li @click="activeMenuLink = '/cut-sew/warehouse'"><router-link to="/cut-sew/warehouse"  :class="{'is-active':activeMenuLink === '/cut-sew/warehouse'}">Ready For Makeup</router-link></li>
            <li @click="activeMenuLink = '/cut-sew/cutting-planner'"><router-link to="/cut-sew/cutting-planner"  :class="{'is-active':activeMenuLink === '/cut-sew/cutting-planner'}">Cutting Planner</router-link></li>
            
          </ul>
        </li>

        <li>
          <a class="">Makeup</a>
          <ul>
            <li @click="activeMenuLink = '/offshore/makeup'"><router-link to="/offshore/makeup"  :class="{'is-active':activeMenuLink === '/offshore/makeup'}">Makeup In Progress</router-link></li>
            <li style="display:none" @click="activeMenuLink = '/cut-sew/makeup-complete'"><router-link to="/cut-sew/makeup-complete"  :class="{'is-active':activeMenuLink === '/cut-sew/makeup-complete'}">Makeup Complete</router-link></li>
            
          </ul>
        </li>
        <li>
          <a class="">Reporting</a>
          <ul>
            <li @click="activeMenuLink = '/cut-sew/cutting-report'"><router-link to="/cut-sew/cutting-report"  :class="{'is-active':activeMenuLink === '/cut-sew/cutting-report'}">Cutting Report</router-link></li>
            
          </ul>
        </li>

        <li>
          <a class="">Data Input</a>
          <ul>
            <li @click="activeMenuLink = '/cut-sew/data-input'"><router-link to="/cut-sew/data-input" target="_blank" :class="{'is-active':activeMenuLink === '/cut-sew/data-input'}">Offshore Scanning</router-link></li>
            
          </ul>
        </li>
        <li>
          <a class="">PMS System</a>
          <ul>
            <li @click="activeMenuLink = '/cut-sew/export-pms'"><router-link to="/cut-sew/export-pms"  :class="{'is-active':activeMenuLink === '/cut-sew/export-pms'}">Export to CSV</router-link></li>
            
          </ul>
        </li>

       
        
        
      </ul>
      
    </aside>
    
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarOffshore',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks
        });
	}
}

</script>



